import axios, { AxiosError, AxiosInstance } from "axios";
import { v4 as uuidv4 } from "uuid";

import { BASE_AUTH, BASE_URL, IS_LOCAL } from "./config";

import storage, { StorageService } from "services/storage";
import communityApi, { CommunityApi } from "./routes/community";

type Token = string | null;

export class ClientApi {
  private _token: Token = null;

  public community: CommunityApi;

  constructor(
    private apiProvider: AxiosInstance,
    private storage: StorageService,
    private readonly _sessionId: string
  ) {
    // this.instance = axios.create({ baseURL: `${url}`, timeout: 15000 });
    apiProvider.interceptors.request.use(
      (config) => {
        if (localStorage.getItem("@jwtToken") !== null) {
          config.headers["Authorization"] = `Bearer ${localStorage.getItem(
            "@jwtToken"
          )}`;
        }
        config.headers["Basic-Auth"] = BASE_AUTH;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    apiProvider.interceptors.response.use(
      (res) => res,
      async (error: AxiosError) => {
        if (error.response?.status === 401) {
          // await this.updateToken();
        }
        throw error;
      }
    );

    this.community = communityApi(this.apiProvider);
  }

  get sessionId() {
    return this._sessionId;
  }

  set token(newToken: Token) {
    this._token = newToken;
  }

  /**
   * @refactoring
   */
  // private async updateToken() {
  //   if (IS_LOCAL) {
  //     const { data } = await this.profile.login();
  //     this.token = data.data.accessToken;
  //     this.storage.setItem("accessToken", data.data.accessToken);
  //   }
  // }
}

const config = {
  baseURL: `${BASE_URL}`,
  timeout: 15000,
};

const clientApi = new ClientApi(axios.create(config), storage, uuidv4());

export default clientApi;
